module.exports = __webpack_public_path__ + "img/index4.75e91179.png";